import moment from "moment";
import commonFn from "@/commons/commonFunction";

export default {
  resetState(state) {
    let x = 1;
    //Object.assign(state, defaultConfigState);
  },
  updateConfig: function(state, payload) {
    let currentDate = moment(payload.CurrentDate).toDate();
    state.ConfigInfo = {
      ...state.ConfigInfo,
      ...payload,
      CurrentDate: currentDate,
      CurrentDateText: moment(currentDate).format("YYYY-MM-DD HH:mm:ss")
    };
  },
  updateOrganizationUnit: function(state, payload) {
    let org = {},
      fields = [
        "OrganizationUnitID",
        "OrganizationUnitName",
        "MISACodeID"
      ];
    fields.forEach(i => {
      org[i] = payload[i];
    });

    //org
    state.OrganizationUnit = org;
    commonFn.setLocalStorage('OrganizationUnit', JSON.stringify(org));

    //update context
    state.Context.OrganizationUnitID = payload.OrganizationUnitID;
    state.Context.MISACodeID = payload.MISACodeID;
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  updateCulture: function(state, payload) {
    state.Context.Culture = payload;
  },
  updateToken(state, payload) {
    state.TokenTimeout = new Date().addHours(payload.tokenTimeout).getTime();
    state.Token = payload.token;

    let context = {};
    for (let i in payload.context) {
      let value = payload.context[i];
      if (value != null && typeof value !== 'undefined') {
        context[i] = value;
      }
    }
    state.Context = context;
    state.User = payload.user;
    state.GettingStarted = payload.getting;
    //NMSINH: xử lý phân quyền
    let permission = {};
    if (Array.isArray(payload.permission) && payload.permission.length > 0) {
      payload.permission.forEach(item => {
        let role = JSON.parse(item);
        if (Array.isArray(role)) {
          role.forEach(r => {
            if (Array.isArray(r.Childrens)) {
              r.Childrens.forEach(c => {
                let code = c.SubSystemCode;
                if (!permission.hasOwnProperty(code)) {
                  permission[code] = [];
                }
                if (Array.isArray(c.Permissions)) {
                  c.Permissions.forEach(p => {
                    var checkHas = permission[code].find(x=>x.code == p.code);
                    if (checkHas == null) {
                      permission[code].push(p);
                    }else {
                      if(checkHas.selected == false){
                        checkHas.selected = p.selected;
                      }
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
    state.Permission = permission;
    state.OrganizationUnit = payload.org;
    // License
    state.License = payload.license;
    //ghi nhớ là lần đầu đăng nhập
    state.FirstLogin = payload.FirstLogin;
    //ghi context vào localstorage
    commonFn.setLocalStorage("FirstLogin", JSON.stringify(state.FirstLogin));
    commonFn.setLocalStorage("Permission", JSON.stringify(state.Permission));
    commonFn.setLocalStorage("TokenTimeout", state.TokenTimeout);
    commonFn.setLocalStorage("Token", state.Token);
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
    commonFn.setLocalStorage("User", JSON.stringify(state.User));
    commonFn.setLocalStorage("OrganizationUnit", JSON.stringify(state.OrganizationUnit));
    commonFn.setLocalStorage("License", JSON.stringify(state.License));
    commonFn.setLocalStorage("LicenseError", payload.licenseError);
    if (state.GettingStarted) {
      commonFn.setLocalStorage("GettingStarted", JSON.stringify(state.GettingStarted));
    }
  },
  updateContext(state, payload) {
    state.Context = payload;
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  updateLoading(state, payload) {
    state.Loading = payload;
  },
  updatePermission(state, payload) {
    state.Permission = payload;
  },
  updateFirstLogin(state,payload){
    state.FirstLogin = payload;
  },
  /**
   * clear thông tin phiên đăng nhập
   */
  removeToken(state) {
    state.Token = null;
    state.Context = null;
    state.User = null;
    state.Permission = null;
    state.FirstLogin = true;

    //ghi context vào localstorage
    commonFn.removeLocalStorage("Permission");
    commonFn.removeLocalStorage("TokenTimeout");
    commonFn.removeLocalStorage("Token");
    commonFn.removeLocalStorage("Context");
    commonFn.removeLocalStorage("User");
    commonFn.removeLocalStorage("GettingStarted");
    commonFn.removeLocalStorage("OrganizationUnit");
    commonFn.removeLocalStorage("License");
    commonFn.removeLocalStorage("LicenseError");
  },
  updateLeftMenuCollapse(state, payload) {
    state.LeftMenuCollapse = payload;
  },
  completeGetting(state) {
    let getting = {
      GettingStarted: true,
      SeenGetting: true
    };
    state.GettingStarted = getting;
    commonFn.setLocalStorage("GettingStarted", JSON.stringify(getting));
    window._getting = getting;
    
  }
};
